import React, { useLayoutEffect } from 'react'
import { PageHero } from 'organisms'

const portfolioRows = [
  { portfolio: 'Portfolio 1', amount: '16,60,79,763.00' },
  { portfolio: 'Portfolio 2', amount: '12,71,87,933.36' },
  { portfolio: 'Portfolio 3', amount: '11,50,58,373.00' },
  { portfolio: 'Portfolio 4', amount: '5,99,31,995.20' },
  { portfolio: 'Portfolio 5', amount: '2,32,61,243.00' },
  { portfolio: 'Portfolio 6', amount: '91,27,284.50' },
  { portfolio: 'Portfolio 7', amount: '13,97,888.00' },
]

const totalAmount = '50,20,44,480.06'

export default function DlgDisclosure() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="flex flex-col flex-1">
      <PageHero
        title="ETRIBE FINANCE PRIVATE LIMITED - Website Disclosure"
        className="text-lg md:text-xl lg:text-2xl"
      />

      <section className="w-container flex-1 py-8 md:py-10 px-3 sm:px-5">
        <div className="max-w-5xl mx-auto text-blueGreen">
          <div className="space-y-4">
            <h2 className="text-xl md:text-2xl font-medium leading-snug">
              DISCLOSURE UNDER GUIDELINES ON DEFAULT LOSS GUARANTEE (DLG)
            </h2>
          </div>

          <div className="overflow-x-auto rounded-lg border border-blueGreen/20 mt-4">
            <table className="w-full border-collapse">
              <thead className="bg-blueGreen/10">
                <tr>
                  <th className="text-left p-4 text-sm md:text-base font-medium uppercase tracking-wide">
                    Portfolio No
                  </th>
                  <th className="text-left p-4 text-sm md:text-base font-medium uppercase tracking-wide">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {portfolioRows.map((row) => (
                  <tr key={row.portfolio} className="border-t border-blueGreen/15">
                    <td className="p-4 text-sm md:text-base">{row.portfolio}</td>
                    <td className="p-4 text-sm md:text-base">{row.amount}</td>
                  </tr>
                ))}
                <tr className="border-t border-blueGreen/15 bg-blueGreen/5 font-medium">
                  <td className="p-4 text-sm md:text-base">Total</td>
                  <td className="p-4 text-sm md:text-base">{totalAmount}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  )
}
